export default "__VITE_ASSET__BStkg2Yo__"